import React from 'react';
import { AppContext } from '../../contexts/AppContext';

export default function useAppContext() {
  return React.useContext(AppContext);
}
